import XLSX from 'xlsx';

/**
 * Build worksheet AOA with a title row and two header rows,
 * a column header spans two rows and a group header spans its sub columns.
 *
 * @param {string} title
 * @param {Array<{ header: string, width: number } | { group: string, columns: Array<{ header: string, width: number }> }>} columns
 * @param {Array<Array<string>>} rows
 * @returns {{ aoa: Array<Array<string>>, merges: Array<object>, cols: Array<object> }}
 */
export const formatGroupedHeaderAOA = (title, columns, rows) => {
  const groupHeaderRow = [];
  const headerRow = [];
  const merges = [];
  const cols = [];

  columns.forEach(column => {
    const startColumnIndex = groupHeaderRow.length;
    if (column.group) {
      column.columns.forEach(({ header, width }) => {
        groupHeaderRow.push(column.group);
        headerRow.push(header);
        cols.push({ wch: width });
      });
      merges.push({
        s: { r: 1, c: startColumnIndex },
        e: { r: 1, c: startColumnIndex + column.columns.length - 1 },
      });
    } else {
      groupHeaderRow.push(column.header);
      headerRow.push('');
      cols.push({ wch: column.width });
      merges.push({ s: { r: 1, c: startColumnIndex }, e: { r: 2, c: startColumnIndex } });
    }
  });
  merges.unshift({ s: { r: 0, c: 0 }, e: { r: 0, c: cols.length - 1 } });

  return { aoa: [[title], groupHeaderRow, headerRow, ...rows], merges, cols };
};

export const writeGroupedHeaderWorkbook = ({ title, columns, rows, sheetName, fileName }) => {
  const { aoa, merges, cols } = formatGroupedHeaderAOA(title, columns, rows);
  const worksheet = XLSX.utils.aoa_to_sheet(aoa);
  worksheet['!merges'] = merges;
  worksheet['!cols'] = cols;

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
  XLSX.writeFile(workbook, fileName);
};
